import { render, staticRenderFns } from "./DeleteOffer.vue?vue&type=template&id=012e7170"
import script from "./DeleteOffer.vue?vue&type=script&lang=js"
export * from "./DeleteOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports